import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/48_halloween_pumpkin/48_halloween_pumpkin"
 * Contains 1 texture(s)
 */
export class Desktop48HalloweenPumpkinAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/48_halloween_pumpkin/48_halloween_pumpkin';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '48_halloween_pumpkin.jpg'
    ] as const;
}
